import { get, set } from 'lodash'
import { parse } from 'qs'

let preloadedState = {}

const { oauth } = parse(window.location.search.slice(1))
if (oauth) {
  try {
    let { settings, error: oauthError, provider } = JSON.parse(
      window.atob(oauth)
    )

    // OAuth is coming from oauth-service
    if (!oauthError && settings.access_token) {
      settings = {
        'access-token': settings.access_token,
        ...settings // include other settings (like refresh_token)
      }
    }

    // Format oauthErrors
    if (oauthError) {
      oauthError = {
        title: 'Authentication Error',
        message: 'We were unable to authenticate your account.'
      }
    }

    set(preloadedState, 'application.setup', {
      isHidden: false,
      type: 'source'
    })

    set(preloadedState, 'application.sourceSetup', {
      sourceSlug: provider,
      step: 'connect',
      oauthError,
      source: { settings }
    })

    preloadedState.oauth = {
      [provider]: {
        oauthError,
        settings
      }
    }

    // Remove oauth querystring from URL
    // I'd much rather this live somewhere else and keep `preloaded-state` pure
    if (get(window, 'history.replaceState'))
      window.history.replaceState({}, '', window.location.pathname)
  } catch (err) {
    // ignore
  }
}

// load auth flow flags
const isInAuthFlow = window.localStorage.getItem('isInAuthFlow')
if (isInAuthFlow) {
  window.localStorage.removeItem('isInAuthFlow')
  set(preloadedState, 'oauth.localStorageFlags', {
    isInAuthFlow,
    shouldBeSuccessful: true
  })
}

export default preloadedState
